<template>
	<div>
        <dialogue
		:title="'Add Job Order to Trip '+tripid"
		:button_names="['Add']"
		:show="add_dialogue"
		:autoClose="false"
		:html="add_html"
        :autocompleteId="58"
		v-on:dialogue="addDialogue"
		v-on:cancel="addDialogueCancel"
		></dialogue>

		<layout-1
            v-if="tripid==null"
			:table_name="'Trips'"
			:id=pageid1
			:searchbar=true
			:navbar=true
			:nav_items="['Add Trip']"
			:nav_item_perms="['134']"
			:button_perm="'134'"
			:button_name="'Select'"
			:term=term
            v-on:select="selectTrip"
			style="width:100%; height:calc(100vh - 50px);"
		></layout-1>
        <div v-else>
            <layout-1
                :table_name="'Trip '+tripid"
                :id=pageid2
                :key=updateKey
                :navbar=true
                :nav_items="['Add Job Order', 'Edit Trip']"
                :nav_item_perms="['134', '134']"
                v-on:button="selectButton"
                :term=tripid
                style="width:100%; height:calc(100vh - 50px);"
            ></layout-1>
        </div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid1:PAGES.TRIPS_PAGE,
			pageid2:PAGES.TRIP_JOBORDERS_PAGE,
			tripid:null,

            add_dialogue:false,
            updateKey:0,
		}
	},
    created () {
        if(this.term!='' && this.term!=undefined) {
            this.tripid = this.term
        }else {
            this.tripid = null
        }
	},
    methods: {
		selectTrip(data) {
            router.push('/0334'+'?q='+data[0]);
		},
        selectButton(name){
            if(name=='Add Job Order') {
                this.add_dialogue = true
            }
        },
        addDialogue(name, value) {
            api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid2,
						data:[this.tripid, value],
					}
				}
			).then((res) => {
                this.updateKey++
                this.add_dialogue = false
            })
        },
        addDialogueCancel() {
            this.add_dialogue = false
        },
    },
    watch: {
        '$route'(to, from) {
            if(this.term!='' && this.term!=undefined) {
                this.tripid = this.term
            }else {
                this.tripid = null
            }
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/view/Trips.vue